import { render, staticRenderFns } from "./ItemTemplate.vue?vue&type=template&id=5ed8e984&"
import script from "./ItemTemplate.vue?vue&type=script&lang=js&"
export * from "./ItemTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports